const imgTeamGraphic2Poster3 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img12032 = "./assets/figma/7f2a7ce8-be0d-428a-8606-8c1344abe439.png";
const img2026923382 = "./assets/figma/221a0709-28db-4d8c-a722-6c06f1ed6284.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/418cccde-c404-479a-9d33-5dd4ffac3b77.png";
const img2026923384 = "./assets/figma/499d08db-cdaa-42da-9329-1fa92527a224.png";
const img2026923385 = "./assets/figma/10b9af6d-7016-4cc1-bdab-56e95e2535e6.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgJpg1 = "./assets/figma/a164fd26-e56e-4615-b816-55ffec9e01b4.png";
const img12311 = "./assets/figma/a11fb534-e6ef-4664-ae15-8dc10ca32c2b.png";
const imgUntitled109Png1 = "./assets/figma/8150f8e5-4504-4525-8a79-484aa20f70b4.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/0910cb02-95b1-474b-946c-10878436c4c0.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/4089bed5-72aa-4d54-b8a7-191cd88f882f.svg";
const imgRectangle247 = "./assets/figma/0a0f13d0-9cdf-414b-9cf7-8d46976f3008.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGraphic2Poster3() {
  return (
    <div className="s0 s1" data-node-id="875:2373" data-name="TEAM_GRAPHIC_2/POSTER3">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s661 s9 s10 s662" src={imgTeamGraphic2Poster3} />
        </div>
      </div>
      <div className="s2 s12 s663 s717 s15" data-node-id="875:2375" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s664 s718 s22" data-node-id="875:2376">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:2377">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2378">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2379">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:2380">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:2381">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2382">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2383">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s719 s54" data-node-id="875:2384">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s665 s27 s29 s720 s57" data-node-id="875:2385">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:2386">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:2387">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s621 s27 s29 s61 s721 s54" data-node-id="875:2388">
        GRAPHIC 2
      </p>
      <div className="s2 s623 s666 s720 s625" data-node-id="875:2389" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12032} />
      </div>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s722 s66" data-node-id="875:2390">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s63 s723 s66" data-node-id="875:2391">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2392">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2393" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2394" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2395" />
          <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:2396">
            POSTER 1
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2397">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2398" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s653 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2399" />
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="875:2400" />
          <p className="s23 s192 s31 s94 s669 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:2401">
            POSTER 2
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2402">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2403" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2404" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2405" />
          <p className="s23 s192 s31 s94 s670 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2406">
            POSTER 3
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s36 s63 s724 s66" data-node-id="875:2407">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2408">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2409" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2410" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2411" />
          <p className="s23 s192 s31 s32 s671 s346 s27 s0 s198 s29 s33 s85 s672" data-node-id="875:2412">
            POSTER 4
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2413">
          <div className="s192 s69 s673 s340 s0 s70 s198 s71" data-node-id="875:2414" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s674 s675 s9 s676 s677" src={img2026923384} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2415" />
          <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:2416" />
          <p className="s23 s192 s31 s94 s678 s346 s27 s0 s198 s29 s33 s85 s679" data-node-id="875:2417">
            GUIDE CARDS
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2418">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2419" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s7 s680 s9 s10 s681" src={img2026923385} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2420" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2421" />
          <p className="s23 s192 s31 s94 s682 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2422">
            POSTCARDS
          </p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:2423">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s683 s108 s109" data-node-id="875:2424" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:2425">
          <div className="s111 s0 s28 s112" data-node-id="875:2426" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:2431">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:2432">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:2433">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2434">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2435">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:2436">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2437">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2438">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:2439">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2440">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2441">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:2442">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:2443">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s67 s153 s725" data-node-id="875:1792">
        <div className="s2 s5 s726 s153 s156 s157 s725 s158" data-node-id="856:2989" />
        <p className="s23 s2 s31 s32 s763 s27 s29 s160 s728 s54" data-node-id="856:2990">
          POSTER 3
        </p>
        <div className="s106 s2 s67 s126 s764" data-node-id="856:3005">
          <div className="s106 s2 s765 s126 s165 s4 s145 s146 s764 s522" data-node-id="856:3006">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s766 s26 s767 s27 s29 s768 s769" data-node-id="856:3007">
            <div className="s16 s17 s24 s172 s770 s26 s0 s28 s528" data-node-id="856:3008">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3009">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34 s38" data-node-id="856:3010">
                <p className="s175 s40">1. 프로젝트 기본 방향</p>
                <p className="s175 s40">DING AI LAB 전시 포스터를 제작할게.</p>
                <p className="s175 s40">인공지능을 통해 아이디어가 구조화되고 확장되는 과정을 투명한 관과 구슬로 표현해줘.각 AI는 고유한 색상과 서로 다른 관의 형태를 가지고있어.</p>
                <p className="s175 s40">투명 구슬: 사용자의 아이디어 투명 관: AI의 사고 구조와 처리 과정 관의 이음새와 장치: 정보의 결합과 변환</p>
                <p className="s175 s40">다양한 관의 형태: AI마다 다른 특징과 역할 전체 분위기: 미래적•실험적·정교한 AI 연구실</p>
                <p className="s175 s40">2. 공통 이미지 제작 조건</p>
                <p className="s175 s40">{`배경은 깨끗한 흰색으로 유지해. 투명한 유리관은 맑고 선명하게 표현해줘. 관의 구조와 이음새는 복잡하고 밀도 높게 제작해. `}</p>
                <p className="s175 s40">각 A의 지정 색상을 관절, 연결 장치, 구슬에 적용해야해. 관 안에는 해당 AI를 상징하는 구슬을 넣고 세포나 생물처럼 보이는 요소는 금지</p>
                <p className="s175 s40">고해상도 3D 이미지로 제작하며 정면에서 바라본 형태로 표현</p>
                <p className="s175 s40">[공통 스타일] 흰색 배경, 투명한 유리 또는 아크릴 재질 고밀도의 연결 장치, 정교한 클램프와 링 선명한 반사와 굴절 약한 반짝임 깨끗한 스튜디오 조명, 미래적인 실험 장비, 텍스트와 불필요한 배경 오브제 제외</p>
                <p className="s175 s40">3. 포스터 구성 프롬프트</p>
                <p className="s175 s40">제작한 8개의 AI 관을 사용하여 DING AI LAB 전시 포스터를 완성할거야</p>
                <p className="s175 s40">중앙에는 DING / AI / LAB 타이틀을 세 줄로 배치하고 가운데 정렬로 맞춰줘 관들은 3열 구조로 배열하며 각 관의 형태와 색상은 변경 금지.</p>
                <p className="s175 s40">상단과 하단의 빈 공간을 보완할 수 있도록 얇은 선, 좌표, 눈금, 십자 표시, 실험 번호 등의 그래픽을 추가해.</p>
                <p className="s175">전체적으로 미래적인 AI 연구실의 설계도와 실험 기록지를 연상시키는 레이아웃으로 구성해줘.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3011">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3012">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3013">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s771 s189 s744 s772" data-node-id="856:3014" data-name="-.jpg 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgJpg1} />
        </div>
        <div className="s2 s773 s774 s775 s776" data-node-id="856:3015" data-name="이미지 1231 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s777 s778 s9 s779 s780" src={img12311} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s715 s27 s29 s137 s762 s54" data-node-id="856:3016">
          PROCESS
        </p>
        <div className="s2 s781 s782 s783 s784" data-node-id="856:3017" data-name="Untitled-1-09.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgUntitled109Png1} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:2740" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
        <p className="s23 s31 s32 s379 s27 s0 s28 s137 s138 s380" data-node-id="875:2741">
          GRAPHIC 2
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="856:2991" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:2992" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:2993">
              POSTER 1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:2994" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:2995">
              POSTER 2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:2996" data-name="TAB_POSTER3">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:2997">
              POSTER 3
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:2998" data-name="TAB_POSTER4">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:2999">
              POSTER 4
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3000" data-name="TAB_GUIDECARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3001">
              GUIDE CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3002" data-name="TAB_POSTCARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3003">
              POSTCARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s785 s212 s213" data-node-id="908:217" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}